import { useEffect } from 'react';
import { HandleCashOfficeActions } from 'src/cash-office-display/business-logic/handle-cash-office-actions';
import { checkAndGetArray } from 'src/common/helpers/array-helper';
import { EndOfDayActivityName } from 'src/end-of-day/business-logic/end-of-day-status';
import { showEndOfDayDialog } from 'src/end-of-day/end-of-day';

export const useEODActivity = eodActivity => {
  useEffect((): void => {
    const activityList = eodActivity.activity;
    if (activityList && activityList.length > 0) {
      const activity = checkAndGetArray(activityList)
        .slice()
        .sort((a, b) => a.priority - b.priority)
        .find(x => !x.isCompleted);

      if (activity) {
        if (activity.name === EndOfDayActivityName.TillDeclaration) {
          HandleCashOfficeActions.openDeclarationActionView();
        } else {
          HandleCashOfficeActions.openTenderPickupActionView();
        }
      } else {
        showEndOfDayDialog();
      }
    }
  }, [eodActivity.activity]);
};
